import { render, staticRenderFns } from "./PopoverContainer.vue?vue&type=template&id=1cdf640e&"
import script from "./PopoverContainer.vue?vue&type=script&lang=js&"
export * from "./PopoverContainer.vue?vue&type=script&lang=js&"
import style0 from "./PopoverContainer.vue?vue&type=style&index=0&id=1cdf640e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports